// External libraries
import $beaver from 'beaver-logger';

// Internal modules
import { isFunction } from '@checkout/react-components';
import { $loggerInit } from './init';
import { getLocale } from '../globals';
import { fpti, initFpti } from './fpti';
import { LOG_PREFIX } from '../constants';

const init = ({ loggerEndpoint, mode, token }) => {
  $loggerInit({ loggerEndpoint, token });
  initFpti({ mode, token });
};

/**
 * @function flushThen
 * @param {func} fn
 * @description Flushes logs and then executes a callback. This
 * is primarily used when redirecting to another page. Before redirecting
 * we flush the logs then we execute the redirect function.
 */
const flushThen = fn => {
  if (!isFunction(fn)) {
    throw new TypeError(
      `expected argument to be a function but got ${typeof fn}`,
    );
  }

  return $beaver.flush().then(fn).catch(fn);
};

const createCustomLogger = logMethod => (logName, payload = {}) => {
  const { locale, country } = getLocale();
  const key = LOG_PREFIX.test(logName) ? logName : `weasley_${logName}`;

  $beaver[logMethod](key, {
    // Common payload
    clientCountry: country,
    clientLocale: locale,
    clientTimestamp: Date.now(),
    ...payload,
  });
};

const $logger = {
  error: createCustomLogger('error'),
  flush: $beaver.flush.bind($beaver),
  flushThen,
  fpti,
  info: createCustomLogger('info'),
  init,
  warn: createCustomLogger('warn'),
};

export { $logger };
